module.exports = __webpack_public_path__ + "f024c1f8bd521cd6190839e91a55533e.pdf";